<template>
  <section class="feature-section">
    <h2 class="section-title">
      <i class="icon icon-feature"></i>
      <span>核心功能</span>
    </h2>
    
    <!-- PC端布局 - 网格 -->
    <div v-if="!isMobile" class="feature-grid">
      <div v-for="(feature, index) in features" :key="index" class="feature-card">
        <div class="feature-icon">
          <i :class="['icon', feature.icon]"></i>
        </div>
        <h3 class="feature-title">{{ feature.title }}</h3>
        <p class="feature-desc">{{ feature.desc }}</p>
      </div>
    </div>
    
    <!-- 移动端布局 - 列表 -->
    <div v-else class="feature-list">
      <div v-for="(feature, index) in features" :key="index" class="feature-item">
        <div class="feature-icon">
          <i :class="['icon', feature.icon]"></i>
        </div>
        <div class="feature-content">
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p class="feature-desc">{{ feature.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    features: {
      type: Array,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.feature-section {
  margin: 40px 0;
}

.mobile-layout .feature-section {
  margin: 30px 0;
}

/* PC端网格布局 */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.feature-card {
  background: var(--white);
  border-radius: 12px;
  padding: 24px;
  box-shadow: var(--box-shadow);
  text-align: center;
  transition: transform 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.feature-icon {
  font-size: 48px;
  color: var(--primary-color);
  margin-bottom: 16px;
}

.feature-title {
  font-size: 18px;
  margin-bottom: 12px;
  color: var(--text-color);
}

.feature-desc {
  font-size: 14px;
  color: var(--secondary-text);
  line-height: 1.6;
}

/* 移动端列表布局 */
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  background: var(--white);
  border-radius: 12px;
  padding: 16px;
  box-shadow: var(--box-shadow);
}

.feature-icon {
  font-size: 32px;
  color: var(--primary-color);
  margin-right: 16px;
  flex-shrink: 0;
}

.feature-content {
  flex: 1;
  text-align: left;
}

.mobile-layout .feature-title {
  font-size: 16px;
  margin-bottom: 8px;
}

.mobile-layout .feature-desc {
  font-size: 13px;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .feature-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .feature-grid {
    grid-template-columns: 1fr;
  }
}
</style>